import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email('Ogiltig e-postadress'),
  password: z.string().min(1, 'Lösenord är obligatoriskt'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
